import Box from "../../components/common/Box";
import Typography from "../../components/common/Typography";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "../../components/common/Table";
import { useEffect, useState } from "react";
import { Breadcrumbs, Link } from "../../components/common/Breadcrumbs";
import { useTheme } from "@mui/material";
import Search from "../../components/common/Search";
import { activeUsers } from "../../mock-data/activeUsers";
import LangchainIcon from "../../assets/img/langchainApp.svg";
import { useHistory } from "react-router-dom";
import Tooltip from "../../components/common/Tooltip";
import HarmfulBadge from "../../components/common/HarmfulBadge";
import { retrievalUserDetails } from "../../mock-data/retrievalUserDetails";
import NoData from "../../components/common/NoData";

const AllUsersPage = () => {
  const [users, setUsers] = useState<Array<any>>([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const history = useHistory();
  const theme = useTheme();
  const styles = {
    page: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
    },
    activeLink: { color: theme.palette.surface80.main },
    blueLink: {
      color: theme.palette.primaryBlue.main,
    },
    breadCrumbLink: {
      fontSize: theme.typography.caption,
    },
    users: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    tableTitle: {
      display: "flex",
      justifyContent: "space-between",
    },
    tableContainer: {
      backgroundColor: theme.palette.surface10.main,
    },
    font13: {
      fontSize: "13px",
    },
    userApps: {
      display: "flex",
      gap: theme.spacing(1),
      alignItems: "center",
      paddingY: theme.spacing(1),
    },
    datastore: {
      display: "flex",
      gap: theme.spacing(0.5),
      alignItems: "center",
      paddingY: theme.spacing(0.5),
    },
    alignBaseline: {
      alignItems: "baseline",
    },
  };

  useEffect(() => {
    setUsers(retrievalUserDetails);
  }, []);

  const gotoUserDetails = (name) => {
    history.push(`/users/${name}`);
  };

  useEffect(() => {
    const filteredList = retrievalUserDetails.filter((user) =>
      user.name.toLowerCase().includes(searchKeyword.toLowerCase())
    );
    setUsers(filteredList);
  }, [searchKeyword]);

  return (
    <Box sx={styles.page}>
      <Breadcrumbs sx={styles.breadCrumbLink}>
        <Link underline="hover" color="inherit" href="/" sx={styles.blueLink}>
          Home
        </Link>
        <Typography variant="caption" sx={styles.activeLink}>
          Active Users
        </Typography>
      </Breadcrumbs>

      <Box sx={styles.users}>
        <Box sx={styles.tableTitle}>
          <Typography>Users ({users?.length})</Typography>
          <Search
            placeholder="Search By User Name"
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            onClear={() => setSearchKeyword("")}
            onKeyDown={(e) => {}}
          />
        </Box>
        <TableContainer sx={styles.tableContainer}>
          <Table>
            <TableHead>
              <TableCell>Users</TableCell>
              <TableCell>Groups</TableCell>
              <TableCell>Applications</TableCell>
              <TableCell>Sensitive Data in Responses</TableCell>
              <TableCell>Sensitive Data in Prompts</TableCell>
            </TableHead>
            <TableBody>
              {users?.length ? (
                users.map((user) => (
                  <TableRow onClick={() => gotoUserDetails(user?.name)}>
                    <TableCell>
                      <Typography
                        sx={styles.font13}
                        color={theme.palette.surface70.main}
                      >
                        {user?.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={styles.font13}
                        color={theme.palette.surface70.main}
                      >
                        {user?.groups?.length}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={styles.userApps}>
                        {user.apps.map((app) => (
                          <Tooltip
                            title={app}
                            children={
                              <img src={LangchainIcon} height={24} alt="app" />
                            }
                          />
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {user?.sensitiveResponse?.value ? (
                        <Box sx={styles.datastore}>
                          {user?.sensitiveResponse?.anamolous && (
                            <HarmfulBadge />
                          )}
                          <Box
                            sx={{
                              ...styles.datastore,
                              ...styles.alignBaseline,
                            }}
                          >
                            <Typography
                              variant="body2"
                              color={theme.palette.surface80.main}
                            >
                              {user?.sensitiveResponse?.value}
                            </Typography>
                            <Typography
                              sx={styles.font13}
                              color={theme.palette.surface50.main}
                            >
                              {`/ ${user?.sensitiveResponse?.outOf}`}
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            color={theme.palette.critical.main}
                            sx={{ marginLeft: theme.spacing(0.5) }}
                          >
                            {user?.sensitiveResponse?.anamolous} Anamolous
                            Prompts
                          </Typography>
                        </Box>
                      ) : (
                        0
                      )}
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{ ...styles.datastore, ...styles.alignBaseline }}
                      >
                        <Typography
                          variant="body2"
                          color={theme.palette.surface80.main}
                        >
                          {user?.sensitivePrompts?.value}
                        </Typography>
                        <Typography
                          sx={styles.font13}
                          color={theme.palette.surface50.main}
                        >
                          {`/ ${user?.sensitivePrompts?.outOf}`}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5}>
                    <NoData customText="No Users" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default AllUsersPage;
